import { render, staticRenderFns } from "./OnlineDetail.vue?vue&type=template&id=13e502a0&scoped=true&"
import script from "./OnlineDetail.vue?vue&type=script&lang=js&"
export * from "./OnlineDetail.vue?vue&type=script&lang=js&"
import style0 from "./OnlineDetail.vue?vue&type=style&index=0&id=13e502a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e502a0",
  null
  
)

export default component.exports